import { PublicKey } from "@solana/web3.js";
import MarketInfoBar from "components/Secondary/MarketInfoBar";
import MarketSelector from "components/Secondary/MarketSelector";
import { formatNumber } from "helpers/helpers";
import useWindowDimensions from "helpers/screen";
import "./style.scss";

const TopBar = ({marketData, updateMarket}) => {
  
  const {width} = useWindowDimensions();
  
  if(width > 768)
  return <div className="tradeTopBar">
    <div className="side">
      <MarketSelector marketData={marketData} updateMarket={updateMarket}/>
      <p className="tickerPrice">{marketData.orderbook && formatNumber(marketData.orderbook.currentPrice, "10")}</p>
      <hr className="separator"/>
      <MarketInfoBar marketData={marketData}/>
    </div>
  </div>

  if(width <= 768)
  return <>
    <div className="tradeTopBar" style={{padding: "0 1.6rem 0 0"}}>
      <div className="side">
        <MarketSelector marketData={marketData} updateMarket={updateMarket}/>
        <p className="tickerPrice">{marketData.orderbook && formatNumber(marketData.orderbook.currentPrice, "10")}</p>
      </div>
    </div>
    {/* <div className="tradeTopBar" style={{padding: "0 0 0 1.6rem"}}>
      <div className="side">
        <MarketInfoBar/>
      </div>
    </div> */}
  </>
}

export default TopBar;